import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {TeammateModel} from '../../../models/api/teammateModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';

/*
 * Reducer.
 */

const teammatesUpdatedReducer = createResourcesUpdatedReducer('teammates', (teammate) => teammate.id);

export function teammatesReducer(
  state: ResourceMap<TeammateModel>,
  action: AppAction,
): ResourceMap<TeammateModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return teammatesUpdatedReducer(state, action);

    default:
      return state;
  }
}
